import { createStyles } from "antd-style"

export const useStyles = createStyles(({ css }) => ({
  button: css`
    svg {
      margin-inline-end: 0 !important;
    }
  `,
}))
